import { themeGet } from "@styled-system/theme-get";

const TAG_SELECTOR_MIN_WIDTH = "300px";

const withMinWidth = (styleFn) => (provided, state) => ({
  ...(typeof styleFn === "function" ? styleFn(provided, state) : provided),
  minWidth: TAG_SELECTOR_MIN_WIDTH,
});

const updateStyles = (customStyles, theme) => {
  const { multiValueLabel } = customStyles;
  const updatedMultiValueLabel = (provided, state) => {
    const styles = multiValueLabel(provided, state);

    return {
      ...styles,
      backgroundColor: "transparent",
      padding: "0 !important",
      borderRadius: "0 !important",
    };
  };

  const menuList = (styles) => ({
    ...styles,
    backgroundColor: "white",
    maxHeight: "250px",
    paddingTop: 0,
    paddingBottom: 0,
  });

  const option = (styles, state) => ({
    ...styles,
    padding: themeGet("space.s")({ theme }),
    backgroundColor: state.isSelected ? "#d2eeff" : "white",
    ":hover": {
      backgroundColor: "#d2eeff",
    },
  });

  const singleValue = (styles) => ({
    ...styles,
    display: "flex",
  });

  return {
    ...customStyles,
    control: withMinWidth(customStyles.control),
    menu: withMinWidth(customStyles.menu),
    menuList,
    option,
    singleValue,
    multiValueLabel: updatedMultiValueLabel,
  };
};

export const TAG_SELECTOR_CONTROL_MIN_WIDTH = TAG_SELECTOR_MIN_WIDTH;

export default updateStyles;
